export default __webpack_public_path__ + "static/media/rain-lightning.0d306de1.mp4";